import { render } from "./CadastrarNewsLetter.vue?vue&type=template&id=1d215546&scoped=true"
import script from "./CadastrarNewsLetter.vue?vue&type=script&lang=js"
export * from "./CadastrarNewsLetter.vue?vue&type=script&lang=js"

import "./CadastrarNewsLetter.vue?vue&type=style&index=0&id=1d215546&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d215546"]])

export default __exports__